import { Box } from '@mui/material';

interface CounterBadgeProps {
    value: number | string;
}

export function CounterBadge({ value = 0 }: CounterBadgeProps) {
    if (value === null || value === undefined) return null;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 4,
                left: 8,
                backgroundColor: 'white',
                color: 'primary.main',
                borderRadius: '50%',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'primary.main',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
                fontWeight: 600,
                boxShadow: 1,
            }}
        >
            {value}
        </Box>
    );
}
